import Styleguide from "@store/Framework/Types/Styleguide";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

const lists: Styleguide["lists"] = {
    defaultProps: {
        css: css`
            ${spacingStyles()}
            padding-left: 1em;

            li {
                ${spacingStyles(null, "0.25em")}
                padding-left: 0;
            }
        `,
    },
};

export default lists;
